/**
 * patientMedia.ts — Staff LK proxy to MIS patient-media sources.
 */
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { AuthSession } from '../../../../types/plans'

export type PatientMediaCandidate = {
  asset_count: number
  linked: boolean
}

export type PatientMediaSourceSnapshot = {
  linked: boolean
  assets: unknown[]
  candidates: PatientMediaCandidate[]
}

export async function listPatientMediaSources(params: {
  bootstrap: TenantBootstrapModel
  session: AuthSession
  patientId: string
}): Promise<PatientMediaSourceSnapshot[]> {
  const res = await fetch(
    `${params.bootstrap.apiBase}/staff/patient-media/patients/${params.patientId}/sources`,
    { headers: { Authorization: `Bearer ${params.session.accessToken}` } },
  )
  if (!res.ok) throw new Error(`patient-media ${res.status}`)
  return res.json() as Promise<PatientMediaSourceSnapshot[]>
}
